<template>
    <div>
        <loadings v-if="loading"></loadings>
        <template v-else>
            <headers :title="title"></headers>
            <div class="list_box">
                <div class="list"
                     ref="meun">
                    <div class="list_warp clearfix">
                        <span v-for="(q,index) in question"
                              :class="{'active':index==swiperIndex}"
                              :key="index"
                              @click="chooseIndex($event,index)">{{index+1}}</span>
                    </div>
                </div>
            </div>
            <div class="listWarp">
                <Swiper class="clearfix"
                        :style="{'height':swiperSlideHeight}"
                        :options="swiperOption"
                        ref="mySwiper"
                        @slideChange="slideChange">
                    <SwiperSlide v-for="(q,i) in question"
                                 :key="`slide${i}`">
                        <mathCom :type="'task'"
                                 :questions="[q]"
                                 :sid="sid"
                                 :showNum="true"
                                 v-if="sid==21||sid==22">
                        </mathCom>

                        <chinese :type="'task'"
                                 :questions="[q]"
                                 :sid="sid"
                                 :showNum="true"
                                 v-else></chinese>
                    </SwiperSlide>
                </Swiper>
            </div>

        </template>
    </div>
</template>

<script>
import headers from "COMPONENTS/base/header.vue";
import loadings from "COMPONENTS/base/loadingS.vue";
import chinese from "./chinese/wrong.vue";
import mathCom from "./math/wrong.vue";
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
// import Swiper from "swiper";
export default {
    components: {
        loadings,
        headers,
        chinese,
        mathCom,
        Swiper,
        SwiperSlide
    },

    data () {
        return {
            title: '第1题',
            loading: false,
            swiperOption: {
                setWrapperSize: true,
                autoHeight: true,
                roundLengths: true, //防止文字模糊
                centeredSlides: true
            },
            swiperIndex: this.$route.query.index,
            sid: this.$route.query.sid,
            cid: this.$route.query.cid,
            unitId: this.$route.query.unitId,
            swiperSlideHeight: null,
            // question:[]
        }
    },
    computed: {
        swiper () {
            // return this.$refs.mySwiper.$swiper  //vue-awesome-swiper  4.X以上的版本要加$
            return this.$refs.mySwiper.$swiper
        },
        question () {
            return JSON.parse(localStorage.getItem('teaTaskQuestion'));
        },
    },
    created () {
        //console.log(this.question)
        this.$store.commit("setLoading", true);
        this.title = `第${Number(this.swiperIndex + 1)}题`;
    },
    mounted () {
        this.$nextTick(() => {
            this.swiper.slideTo(this.swiperIndex);
            if (this.sid == 21 || this.sid == 22) {
                MathJax.Hub.Typeset(document.body)
            }
            this.$store.commit("setLoading", false);
            this.scrollLeft(this.swiperIndex);

        })
    },
    methods: {
        /* 该方法只有swiper4.x以上版本才有，4.x以下没有该方法
        **  vue-awesome-swiper@4.X对应swiper@6.0版本    vue-awesome-swiper@3.X对应swiper@4.0版本
        */
        slideChange (swiper) {
            this.swiperIndex = this.swiper.activeIndex;
            this.scrollLeft(this.swiperIndex);
        },
        chooseIndex (e, index) {
            this.swiper.slideTo(index, 1000, true);
            this.swiperIndex = index;
            this.scrollLeft(index);
            // //console.log(e.target.offsetLeft)
        },
        scrollLeft (index) {
            // (index-4)*宽度+半个宽度
            let left = index < 4 ? 0 : (index - 4) * 50 + 12;
            this.$refs.meun.scrollLeft = left;
            this.title = `第${Number(index + 1)}题`;
            let slide = document.getElementsByClassName("swiper-slide");
            this.swiperSlideHeight = slide[index].offsetHeight + 20 + 'px';
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.listWarp {
    width: 720px / $ppr;
    margin: 0 auto;
    font-size: 28px / $ppr;
    padding-top: 104px / $ppr;

    .swiper-slide {
        display: flex;
        float: left;
    }
}

.swiper-container {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    z-index: 1;
    height: auto;
}

.list_box {
    position: fixed;
    width: 100%;
    top: 96px / $ppr;
    left: 0;
    z-index: 8;
}

.list {
    width: 660px / $ppr;
    margin: 0 auto;
    border-top: 1px solid #eeeeee;
    position: relative;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 30px / $ppr;
    height: 44px / $ppr;
    background: #fff;

    .list_warp {
        width: 660px / $ppr;
        position: absolute;
        top: 30px / $ppr;
        left: 0;
        white-space: nowrap;

        span {
            display: inline-block;
            width: 44px / $ppr;
            height: 44px / $ppr;
            margin: 0 20px / $ppr;
            text-align: center;
            border-radius: 22px / $ppr;
            border: 1px solid #e6e6e6;
            line-height: 44px / $ppr;
            color: #333;

            &.active {
                border: 1px solid #3c7cfb;
                background: #3c7cfb;
                color: #fff;
            }
        }
    }
}
</style>
